import {
    Subject
} from 'one-state-subject/src/Subject';
import { diff } from 'one-util-date';
import {
    EmergencyDetails
} from 'one-state-subject';
import {
    EmployerDetails
} from 'one-state-subject';


// ADPAC-316
function sortFunction(a: Subject, b: Subject) {
    const nameA = a.lastname?.toLowerCase();
    const nameB = b.lastname?.toLowerCase();
    return nameA > nameB ? 1 : -1;
}

const checkAge = (dob: any) => {
    let age = "";
    if (dob !== undefined && dob !== null && dob !== "") {
        age = diff(dob).toString();
    }
    return age;
}

export const formatPhoneNumber = (phoneNumberString: any) => {
    let cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    if (cleaned.length == 10) {
        if (cleaned) {
            return '(' + cleaned.substring(0, 3) + ') ' + cleaned.substring(3, 6) + '-' + cleaned.substring(6, 10);
        }
    }
    return "";
}

/**
 * This Function transforms the backend response
 * in the Data Model that supports the
 * upcoming Appointments Component
 * @param response has the backend upcoming
 * appointment response
 * @param context has settings etc..
 */
export const TransformResponse = (response: any, context: any) => {
    /**
     * @param result contains the transformed response
     */
    const result: Subject[] = [];

    let subjectresult: any = {
        subjectdata: result,
        error: undefined

    }
    const { log, settings: { cernerendpoints, uisettings: { display_patientid } } } = context;
    log.debug("on-epic/cerner-epics", "transformation entered", response);
    // TODO:verify backend team check for errors
    if (response && response.status >= 400) {
        subjectresult.error = response;
    }
    //ADPAC-348
    else if (response && response.length > 0) {
        const rs = response;
        console.log("----Display Data",response)
        rs.map((ele: any) => {
            let source: Subject = {
                initials: "",
                id: "",
                middlename: "",
                mrn: "",
                dob: "",
                gender: "",
                age: "",
                contact: "",
                contact_formatted: "",
                address: "",
                lastname: "",
                firstname: "",
                name: "",
                race: "",
                email: "",
                ssn: "",
                zipcode: "",
                displayid: "",
                displayidtype: "",
                emergencycontact: [],
                employmentinfo: [],
                PatientID: ""
            }
debugger
            if (ele.PatientID) {
                const id = ele.PatientID.filter((object: any) => object.Type === cernerendpoints.searchID)
                const displaydata = ele.PatientID.filter((object: any) => object.Type === display_patientid)

                if (id.length) {
                    source.initials = ele.LastName?.charAt(0) + ele.FirstName?.charAt(0)
                    source.id = id[0].ID;
                    source.mrn = id[0].ID;
                    source.displayid = displaydata[0].ID;
                    source.displayidtype = displaydata[0].Type;
                    source.firstname = ele.FirstName;
                    source.lastname = ele.LastName;
                    source.name = ele.Name;
                    source.dob = ele.DateOfBirth;
                    const age = checkAge(ele.DateOfBirth);
                    source.age = age ? age : "";
                    // source.age = age ? age + " year old " + ele?.Sex : "";
                    source.gender = ele.Sex;
                    source.race = ele.Race;
                    source.ssn = ele.NationalIdentifier;
                    let addrstr = "";
                    let phone = "";
                    let phoneNumbers: any = []
                    let email = "";
                    let emergencydata: EmergencyDetails[] = [];
                    let employerinfo: EmployerDetails[] = [];
                    if (ele.Addresses?.length > 0) {
                        ele.Addresses.map((address: any) => {
                            if (address.Type === 'Permanent') {
                                addrstr = addrstr.concat(address.Street[0] ? address.Street[0] + "," : "");
                                addrstr = addrstr.concat(address.City ? address.City + "," : "");
                                addrstr = addrstr.concat(address.State ? address.State + "," : "");
                                // addrstr = addrstr.concat(address?.Country ? address?.Country + "," : "");
                                addrstr = addrstr.concat(address.PostalCode ? address.PostalCode : "");
                                address.PhoneNumbers?.map((phoneobj: any) => {
                                    if (phoneobj?.Type === 'Home Phone') {
                                        phone = phoneobj.Number
                                    }
                                })
                                phoneNumbers = address.PhoneNumbers
                                address.Email?.map((emailid: any) => {
                                    email = emailid;
                                })
                                source.zipcode = address.PostalCode;
                            }
                        })
                    }
                    if (ele.EmergencyContacts?.length > 0) {
                        ele.EmergencyContacts.map((emerge: any) => {
                            let info = {
                                emergename: emerge?.Name ? emerge.Name : "",
                                contactrelation: emerge?.Relation ? emerge.Relation : "",
                                contactnumber: ""
                            }
                            emergencydata.push(info)
                            emerge.PhoneNumbers.forEach((contactdata: any) => {
                                if (contactdata.Type === "Home Phone") {
                                    info.contactnumber = contactdata.Number
                                }
                            });
                        })

                    }
                    if (ele.EmploymentInformation?.length > 0) {
                        ele.EmploymentInformation.map((emerge: any) => {
                            let info = {
                                employername: emerge?.EmployerName ? emerge.EmployerName : "",
                                occupation: emerge?.Occupation ? emerge.Occupation : "",
                                contactnumber: ""
                            }
                            employerinfo.push(info)
                            emerge.PhoneNumbers.forEach((contactdata: any) => {
                                if (contactdata) {
                                    info.contactnumber = contactdata.Number;
                                }
                            });
                        })
                    }
                    source.address = addrstr;
                    source.contact = phone;
                    const formatednumber = formatPhoneNumber(phone);
                    source.phoneNumbers = phoneNumbers;
                    source.contact_formatted = formatednumber === "" ? phone : formatednumber;
                    source.email = email;
                    source.emergencycontact = emergencydata;
                    source.employmentinfo = employerinfo;
                }
            }

            if (ele.Identifier) {
                const id_all = ele.Identifier.filter((object: any) => object?.type === cernerendpoints?.searchID);
                const displaydata = ele.Identifier.filter((object: any) => object.type === display_patientid)
                /* If we have multiple entries with the same type and in random order of start or end date
                const id_latest = id_all.filter((object:any) => object.startPeriod?object.startPeriod: "");
                const id = id_latest[0];
                */

                const id = id_all[0];
                const displayId = displaydata[0];
                var FirstName;
                var LastName;
                if (id) {
                    let NameArray = ele.Name;
                    FirstName = ele.Name[0]?.given;
                    LastName = ele.Name[0]?.family;
                    NameArray.forEach((element: any) => {
                        if (element?.use == "official") {
                            FirstName = element.given;
                            LastName = element.family;
                        }
                    });
                    source.initials = LastName?.charAt(0) + FirstName?.charAt(0)
                    source.id = id.value;
                    source.mrn = ele.ID;
                    source.displayidtype = display_patientid;
                    source.displayid = displayId.value
                    source.firstname = FirstName;
                    source.lastname = LastName;
                    source.name = LastName + "," + FirstName;
                    source.dob = ele.BirthDate;
                    const age = checkAge(ele.BirthDate);
                    source.age = age ? age : "";
                    // source.age = age ? age + " year old " + ele?.Sex : "";
                    source.gender = ele.Gender;
                    source.race = ele.Race;
                    source.ssn = ele.Identifier[0].value;
                    source.id = ele.ID;
                    let addrstr = "";
                    let phone = "";
                    let phoneNumbers: any = []
                    let email = "";
                    let emergencydata: EmergencyDetails[] = [];
                    let employerinfo: EmployerDetails[] = [];

                    if (ele.Addresses?.length > 0) {
                        for (i = 0; i < ele.Addresses.length; i++) {
                            var address = ele.Addresses[i]
                            if (address?.use === 'home') {
                                addrstr = addrstr.concat(address.line ? address.line + "," : "");
                                addrstr = addrstr.concat(address.city ? address.city + "," : "");
                                addrstr = addrstr.concat(address.state ? address.state + "," : "");
                                // addrstr = addrstr.concat(address?.Country ? address?.Country + "," : "");
                                addrstr = addrstr.concat(address.postalCode ? address.postalCode : "");
                                source.zipcode = address.postalCode;
                                break;
                            }
                        }

                    }

                    if (ele.Telecom) {
                        const Phones = ele.Telecom.filter((object: any) => object?.system === 'phone');
                        const Emails = ele.Telecom.filter((object: any) => object?.system === 'email');
                        phoneNumbers = Phones;

                        for (let telecom of ele.Telecom) {
                            if (telecom?.use === 'home' && telecom?.system === 'phone') {
                                phone = telecom.Number;
                                break;
                            }
                            else {
                                continue;
                            }
                        }

                        if (!phone) {
                            for (let telecom of ele.Telecom) {
                                if (telecom.system === 'phone') {
                                    phone = telecom.Number;
                                    break;
                                }
                                else {
                                    continue;
                                }
                            }
                        }

                        for (let telecom of ele.Telecom) {
                            if (telecom?.use === 'home' && telecom?.system === 'email') {
                                email = telecom.Number;
                                break;
                            }
                            else {
                                continue;
                            }
                        }
                        if (!email) {
                            for (let telecom of ele.Telecom) {
                                if (telecom?.system === 'email') {
                                    email = telecom.Number;
                                    break;
                                }
                                else {
                                    continue;
                                }
                            }
                        }

                    }
                    if (ele.EmergencyContacts?.length > 0) {
                        var i = 1;
                        ele.EmergencyContacts.map((emerge: any) => {
                            let info = {
                                emergename: emerge?.Name.text ? emerge?.Name.text + "-" + i.toString() : "",
                                contactrelation: emerge?.Relation[0].text ? emerge?.Relation[0]?.text : "",
                                contactnumber: ""
                            }
                            emergencydata.push(info)
                            emerge.Telecom?.map((telecom: any) => {
                                if (telecom?.use === 'home' && telecom?.system === 'phone' && telecom?.rank == 1) {
                                    info.contactnumber = telecom.value;
                                }

                            })
                            i++;
                        })
                    }

                    source.address = addrstr;
                    source.contact = phone;
                    const formatednumber = formatPhoneNumber(phone);
                    source.phoneNumbers = phoneNumbers;
                    source.contact_formatted = formatednumber === "" ? phone : formatednumber;
                    source.email = email;
                    source.emergencycontact = emergencydata;
                    source.employmentinfo = employerinfo;
                }
            }
            result.push(source);
        })
    }
    // ADPAC-316
    result.sort(sortFunction);
    subjectresult.subjectdata = result;
    return subjectresult;
}



